import useUser from '../../../../shared/features/user/hooks/useUser';

import usePriceConfig from '../../../../shared/features/priceConfig/hooks/usePriceConfig';
import { getCurrencyForAreaUnit } from '../../../../shared/helpers/functions/currency';
import { StripeSubscriptionItemInput } from '../../../../shared/graphql/graphql';
import rootStore from '../../rootStore/RootStore';
import { Plan } from '../../../../shared/helpers/constants/plans';

export default function useStripeSubscription() {
  const { isCombinedDataLoaded: isCustomerLoaded, customer } =
    useUser(rootStore);
  const { isLoaded: isConfigLoaded, config } = usePriceConfig(rootStore);
  const { checkoutStore, areaUnitStore } = rootStore;
  const { areaUnit } = areaUnitStore;

  const currency = getCurrencyForAreaUnit(areaUnit);

  const saveSubscription = async ({
    annual,
    monthly,
    promocode,
  }: {
    annual?: {
      area: string;
      seats: string;
      planet: string;
    };
    monthly?: boolean;
    promocode?: string;
  }) => {
    if (
      !isCustomerLoaded ||
      !isConfigLoaded ||
      checkoutStore.subscription.inProgress
    ) {
      return null;
    }

    const items: StripeSubscriptionItemInput[] = [];
    let plan: Plan.monthly | Plan.annual;

    if (annual) {
      const annualArea = parseInt(annual.area, 10);
      const annualSeats = parseInt(annual.seats, 10);
      const annualPlanetArea = parseInt(annual.planet, 10);

      plan = Plan.annual;

      items.push({
        price:
          config?.AnnualSubscription.FullAccessToEssentialFunctionalities
            .prices[currency].priceId,
        quantity: annualArea,
      });

      items.push({
        price:
          config?.AnnualSubscription.AdditionalUserSeat.prices[currency]
            .priceId,
        quantity: annualSeats,
      });

      items.push({
        price:
          config?.AnnualSubscription.PlanetImagery.prices[currency].priceId,
        quantity: annualPlanetArea,
      });
    } else if (monthly) {
      const planConfig = config?.MonthlyPayAsYouGo;
      plan = Plan.monthly;

      if (planConfig) {
        Object.values(planConfig).forEach((product) => {
          const { priceId } = product.prices[currency];
          items.push({ price: priceId });
        });
      }
    } else {
      throw new Error(
        '[useStripeSubscription][saveSubscription] Invalid plan.',
      );
    }

    return checkoutStore.saveStripeSubscription({
      plan,
      customerId: customer?.id ?? '',
      items,
      promocode,
      areaUnit,
    });
  };

  return {
    clientSecret: checkoutStore.subscription.clientSecret,
    subscriptionId: checkoutStore.subscription.id,
    isSubscriptionSaving: checkoutStore.subscription.inProgress,
    saveSubscription,
  };
}
